// extracted by css-extract-rspack-plugin
export default {"section":"FlexTemplate-module__section__SL1TS"};